import { render, staticRenderFns } from "./Target.vue?vue&type=template&id=2314e016&scoped=true&lang=pug&"
import script from "./Target.vue?vue&type=script&lang=js&"
export * from "./Target.vue?vue&type=script&lang=js&"
import style0 from "./Target.vue?vue&type=style&index=0&id=2314e016&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2314e016",
  null
  
)

export default component.exports